import React from "react";

import { BrowserRouter, Switch, Route } from "react-router-dom";
import './App.css';
import Dashboard from "./pages/Dashboard";
import { connect } from 'react-redux'
import Logout from "./pages/Logout";
import Account from "./pages/Account";
import Book from "./pages/Book";
import LoginPhone from "./pages/LoginPhone";
import Nav from "./components/Nav";
import Foot from "./components/Foot";
import Consultation from "./pages/Consultation";
import Thanks from "./pages/Thanks";
import About from "./pages/About";



function App(props) {
  return (
    <BrowserRouter>
      <div className="App"
      // style={{ backgroundImage: `url(${isTabletMid()?"none": "images/maxim-bogdanov-GHGzOrYCvwM-unsplash_edits.jpg"})`, width: "100%", height: "1000px", backgroundRepeat: "no-repeat", backgroundSize: "contain" }}
      >
        <Nav />
        <main>
          <Switch>
            <Route exact path="/" component={Dashboard}></Route>
            {/* <Route path="/login" component={LoginEmail} /> */}
            <Route path="/book" component={Consultation} />
            <Route path="/about" component={About} />
            <Route path="/partner" component={Consultation} />
            <Route path="/thankyou" component={Thanks} />
          </Switch>
        </main>
        <Foot />
      </div>
    </BrowserRouter>
  );
}

const mapStateToProps = (state) => ({
  //  auth: state.firebase.auth
})

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(App)

